import React from 'react'
import i18n from 'i18next'
import {usePermissions} from '#hooks/usePermissions'
import {useAzubisWithPraxisaufgaben} from '#hooks/useAzubisWithPraxisaufgaben'
import Headline from '../../components/a/Headline'
import PageHeader from '#components/m/PageHeader'
import {PraxisaufgabenCollection} from '#components/m/PraxisaufgabenOverview/PraxisaufgabenCollection'
import Loading from '#components/a/Loading'
import {useSelector} from 'react-redux'

export default function PraxisaufgabenOverview() {
  const permissions = usePermissions()
  const canFilterByMyAbteilungen = permissions.meineAzubis.canFilterAzubisByMyAbteilungen
  const canViewPraxisaufgabenFromOthers = permissions.praxisaufgaben.viewPraxisaufgabenFromOthers

  const selectedAzubiIdsFromGlobalFilter = useSelector(state => state.filter.matchingAzubiIds)

  const {azubis, loading} = useAzubisWithPraxisaufgaben({
    myAufgabenOnly: !canViewPraxisaufgabenFromOthers,
  })

  const styleForPraxisaufagben = canViewPraxisaufgabenFromOthers ? null : {justifyContent: 'center'}
  const placeholderTextId = canFilterByMyAbteilungen
    ? 'no_azubi_with_this_module_in_your_abteilungen'
    : 'no_azubi_with_this_module'

  let filteredAzubis = azubis

  if (selectedAzubiIdsFromGlobalFilter !== undefined && canViewPraxisaufgabenFromOthers) {
    filteredAzubis = azubis?.filter(azubi => selectedAzubiIdsFromGlobalFilter.includes(azubi.id))
  }

  const mainView = () => {
    if (loading === true) {
      return <Loading />
    }

    return (
      <>
        <PraxisaufgabenCollection
          azubis={filteredAzubis}
          canViewPraxisaufgabenFromOthers={canViewPraxisaufgabenFromOthers}
          style={styleForPraxisaufagben}
          placeholderTextId={placeholderTextId}
          testid="praxisaufgaben_collection_primary"
        />
      </>
    )
  }

  return (
    <div className="praxisaufgaben-overview">
      <PageHeader headline={<Headline importance={1} modifier="section" text={i18n.t('status_overview_title')} />} />
      {mainView()}
    </div>
  )
}
